import React from 'react';
import { useTranslation } from 'react-i18next';
import Block from '../../Block';
import { Date } from '../../Format';
import Table from '../../tables/Table';
import useCustomTable from '../../tables/useCustomTable';

const VersionBlock = ({data = []})=>{
  const { t } = useTranslation();
  const columns = [{
    Header: 'Date',
    accessor: 'date',
    Cell: ({row}) => (<Date dateFormat = 'long' date={row.original.date}/>),
  },{
    Header: "App version",
    accessor: "app_version"
  },{
    Header: "Sdk version",
    accessor: "sdk_version"
  },{
    Header: "Location mode",
    accessor: "manager_mode"
  },{
    Header: "Cmp",
    accessor: "cmp"
  },{
    Header: "background location enabled",
    accessor: "background_location_enabled"
  }]

  const {
    tableProps
  } = useCustomTable({
    sortable: true,
    paginate: false,
    filterable: false,
  })
  return (
    <Block title={t("devices.version")}>
      <Table data={data} columns={columns} {...tableProps} />
    </Block>
  )
}


export default VersionBlock